import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './NoSession.styles';

export const NoSession = () => {
  const { t } = useTranslation(['auth']);

  return (
    <S.NoSessionWrapper>
      <S.Title>{t('auth:noSession.title')}</S.Title>
      <S.Description>{t('auth:noSession.description')}</S.Description>
    </S.NoSessionWrapper>
  );
};
